import React from "react"
import {
  LinearProgress,
  linearProgressClasses,
  Stack,
  Typography
} from "@mui/material"

export const BorderlessLinearProgressWithLabel = ({
  color,
  value,
  label,
  trackColor = "transparent",
  thickness = 10
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={3}>
      <LinearProgress
        sx={{
          flexGrow: 1,
          backgroundColor: trackColor,
          height: thickness,
          borderRadius: thickness / 2,
          [`& .${linearProgressClasses.bar}`]: {
            borderRadius: thickness / 2,
            backgroundColor: color
          }
        }}
        variant="determinate"
        value={value}
        color="primary"
      />
      <Typography variant="h6" color="textSecondary">
        {label}
      </Typography>
    </Stack>
  )
}
